import { render, staticRenderFns } from "./CodAdvancePolicy.vue?vue&type=template&id=87ad00aa&scoped=true"
import script from "./CodAdvancePolicy.vue?vue&type=script&lang=js"
export * from "./CodAdvancePolicy.vue?vue&type=script&lang=js"
import style0 from "./CodAdvancePolicy.vue?vue&type=style&index=0&id=87ad00aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87ad00aa",
  null
  
)

export default component.exports